import script from "./model.vue?vue&type=script&lang=ts&setup=true"
export * from "./model.vue?vue&type=script&lang=ts&setup=true"

import "./model.vue?vue&type=style&index=0&id=3a0d1840&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a0d1840"]])

export default __exports__